import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function DashboardError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot create dashboard'}
    </Alert>
  );
}

export { DashboardError };
